import { BET_BUILDER, TicketTypes } from '@tickets/constants';

export const isDepositTicket = (barcode) => {
  const str = barcode?.toString() || '';
  return str.length >= 12 && str.charAt(0) === '9';
};

export const isCasinoTicket = (barcode) => {
  const str = barcode?.toString() || '';
  return str.length > 13 && str.charAt(0) === '2';
};

export const isSportTicket = (barcode) => {
  const str = barcode?.toString() || '';

  return (str.length > 8 && str.length <= 13) || (str.length === 20 && str.charAt(0) === '1');
};

export const isAdminTicket = (barcode) => {
  const str = barcode?.toString() || '';
  return str.length === 13 && str.charAt(0) === '6';
};

export const isOneTimeLoginTicket = (barcode) => {
  const str = barcode?.toString() || '';
  return str.length === 20 && str.startsWith("88");
};

export const isBetBuilder = (ticket) => ticket?.dataFromSwarm?.type_name === BET_BUILDER;

export const getTicketType = (barcode, ticket) => {
  if (isAdminTicket(barcode)) return TicketTypes.ADMIN;
  if (isDepositTicket(barcode)) return TicketTypes.DEPOSIT;
  if (isCasinoTicket(barcode)) return TicketTypes.CASINO;
  if (isSportTicket(barcode)) return TicketTypes.SPORT;
  if (isBetBuilder(ticket)) return TicketTypes.BET_BUILDER;

  return null;
};
